import { useState } from "react";
import { Button, Form, Input, Label, Select } from "../../../styles";
import { emailPlaceholder, namePlaceholder, phonePlaceholder } from "../../../utils/data";



const EditEmployee = (props) => {

      const { data: { fullname, email, phone } = {} } = {} = props;

      return (
            <>
                  <Form autoComplete="off"                   >
                        <div className="row justify-content-center text-start mt-4">
                              <div className="col-md-12 ">
                                    <Label> Staff Name: </Label>
                                    <Input
                                          type="text"
                                          value={fullname}
                                          disabled
                                          placeholder={namePlaceholder}
                                    />
                              </div>

                              <div className="col-md-12 ">

                                    <Label> Staff email: </Label>

                                    <Input
                                          type="email"
                                          value={email}
                                          disabled
                                          placeholder={emailPlaceholder}
                                    />
                              </div>
                              <div className="col-md-12 ">
                                    <Label> Phone Number: </Label>
                                    <Input
                                          type="text"
                                          value={phone}
                                          disabled
                                          placeholder={phonePlaceholder}
                                    />
                              </div>
                              {/* 
                              <div className="col-md-12  mx-auto text-center">
                                    <div className="mb-4">
                                          <Button
                                                pry
                                                type="submit"
                                                className="btn m-0 w-lg-75 w-md-100"
                                                disabled={issending}
                                          >
                                                {issending ? 'loading...' : 'Submit'}
                                          </Button>
                                    </div>
                              </div> */}
                        </div>
                  </Form>


            </>
      );
};

export default EditEmployee;